import { z } from "zod";
import {
  CITY,
  EMAIL,
  GEOGRAPHICAL_REGION,
  MOBILE,
  NAME,
  ROLE,
  STATE,
} from "../consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [EMAIL]: z
    .string()
    .min(1, "Please fill contact email")
    .email("This is not a valid email."),
 [MOBILE]: z
    .string()
    .min(1, "Mobile number is required")
    .regex(/^[6-9]\d{9}$/, "Invalid mobile number"),
  [ROLE]: z.string().min(1, "This field is required").array(),
  [GEOGRAPHICAL_REGION]: z.string().optional(),
  [STATE]: z.string().min(1, "This field is required"),
  [CITY]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
